import React from 'react';
import { Images } from '../../../shared/app-constants';

const TaskEmptyList = () => (
  <div className="d-flex flex-column justify-content-center align-items-center multichannel-empty-task">
    <img src={Images.MultichannelTask} alt="empty-data" />
    <div className="d-flex flex-column text-center gap-16">
      <span className="title">Manage Your Multichannel Tasks</span>
      <span className="subtitle">
        Create outreach tasks from sequences and track their progress here.
        View, complete, skip or snooze tasks across all channels in one place.
      </span>
    </div>
  </div>
);

export default TaskEmptyList;
